<script>

import api from "../../services/api";
import AddressForm from "../addresses/address-form";

/**
 * Nav-bar Component
 */
export default {
  components: {AddressForm},
  props: {
    location: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
    };
  },
  beforeMount() {
  },
  methods: {
    async submitForm() {
      api.save('addresses', this.location)
          .then((response) => {
            if (response.status !== 200)
              this.$emit('error');
            else
              this.$emit('submitted');
          })
          .catch(() => {
            this.$emit('error');
          });
    },
  }
};
</script>

<template>

  <b-form>
    <b-card no-body class="mb-2 pt-2">
      <b-card-body class="p-0">
        <b-row class="mb-3">
          <b-col>
            <b-form-group label="Nom" label-for="formrow-nom-input">
              <b-form-input id="formrow-nom-input" type="text"
                            v-model="location.name"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <address-form :address="location"></address-form>
      </b-card-body>
    </b-card>


    <div class="text-right">
      <b-button variant="primary" @click="submitForm">Enregistrer</b-button>
      <b-button variant="secondary" @click="$emit('cancel')">Annuler</b-button>
    </div>
  </b-form>
</template>